//
//
//
//
//
//

import Raven from 'raven-js';
import Vue from 'vue';
import RavenVue from 'raven-js/plugins/vue';

export default {
  name: 'app',
  mounted() {
    /**
     * 部署sentry
     */
    (function deploySentry() {
      // Sentry监控
      // DSN的查看在 https://getsentry-web-error-collect.orvibo.com/settings/sentry/tmallgenie-vue-h5/keys/
      const isNeedReport = parseInt(Math.random() * 10) === 0; // 概率分布，避免对服务器造成过大压力
      if (isNeedReport && process.env.NODE_ENV !== 'development') {
        Raven
          .config('https://287de712429346889abdcbb3adde0f4a@getsentry-web-error-collect.orvibo.com/5')
          .addPlugin(RavenVue, Vue)
          .install();
      }
    })();
  }
}



// WEBPACK FOOTER //
// ./src/App.vue